import { useLeadStore } from '../../../../../../store/use-lead-store';
import { LeadContentType } from '../../../../../../store/api/leads-api';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useEffect } from 'react';

export const useLeadForm = () => {
  const { handleUpdateLead, lead, handleResetLead, fetchLead } = useLeadStore();
  const { t } = useLang();

  useEffect(() => {
    fetchLead();
    return () => handleResetLead();
  }, [fetchLead, handleResetLead]);

  const handleUpdateTitle = (e: LangType) => {
    handleUpdateLead({ title: e });
  };

  const handleCheckField = (type: LeadContentType) => {
    const isExist = lead?.content?.some((item) => item.type === type);
    if (isExist) {
      handleUpdateLead({ content: lead?.content?.filter((item) => item.type !== type) });
    } else {
      handleUpdateLead({ content: [...(lead?.content || []), { type, is_required: false }] });
    }
  };

  const handleCheckFieldRequired = (type: LeadContentType) => {
    const content = lead?.content?.map((item) => {
      if (item.type === type) {
        return { ...item, is_required: !item.is_required };
      }
      return item;
    });
    handleUpdateLead({ content });
  };

  const handleCheckAvailable = () => {
    handleUpdateLead({
      display_setting_type: lead?.display_setting_type === 'FULL_ON' ? 'OFF' : 'FULL_ON',
    });
  };

  const handleBack = () => window.history.back();

  return {
    lead,
    handleUpdateTitle,
    handleCheckField,
    handleCheckFieldRequired,
    handleCheckAvailable,
    t,
    handleBack,
  };
};
